import React, {Component, PureComponent} from "react";
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import {AlertModal, ModalHelper, helper}  from "./../app.js"; 

export default class TrayTypeSelecter extends PureComponent 
{
    modal = null;

    constructor (props)
    {
        super(props);

        this.state = {
            type: this.props.type,
            show_perf_filter: this.canPerforated(this.props.type),//'rolled' == this.props.type,
            perforated: this.props.perforated,
            alert_message: ''
        };

        // this.props.types[this.props.type]
        this.modal = new ModalHelper(this);

        this.selectType = this.selectType.bind(this);
        this.setPerforated = this.setPerforated.bind(this);
        this.modal.showTrayChangeWarning = this.modal.showTrayChangeWarning.bind(this.modal);
    }    
    selectType (e)
    {
        const type = e.target.value,
            show_perf_filter = this.canPerforated(type),//'rolled' == type,
            perforated = null;

        this.setState({type, show_perf_filter, perforated});
        this.props.on_select({type, perforated}, 'tray_filter');
    }
    setPerforated (e)
    {
        if (this.canPerforated(this.state.type)) // 'rolled' == this.state.type
        {
            const perforated = 'perforated' == e.target.value;

            this.setState({perforated});
            this.props.on_select({type: this.state.type, perforated}, 'tray_filter');
        }
    }
    canPerforated (type)
    {
        type = `'${type}'`;
        return type in this.props.types && this.props.types[type].indexOf('ороб') > 0;
    }
    render () 
    {
        const typesList = Object.keys(this.props.types).map(type => 
            {
                const typeName = this.props.types[type];
                type = type.replaceAll('\'', '');
                return <option key={type} value={type}>{typeName}</option>;
            });
        typesList.unshift(<option key="none" value="">Тип лотка не выбран</option>);

        return (<><Form.Row>
                <Form.Group as={Col} md={7} className="pb-2" controlId="some_id">       
                    <Form.Label>Тип лотка:</Form.Label>
                    <Form.Control onChange={this.selectType} value={this.state.type} onClick={this.modal.showTrayChangeWarning} custom as="select">{typesList}</Form.Control>
                </Form.Group>
                <Form.Group as={Col} md={5} className={!this.state.show_perf_filter ? 'd-none' : ''}>
                    <Form.Label className="d-none d-md-inline-block">&nbsp;</Form.Label>
                    <div className="mt-n1">
                        <Form.Check onChange={this.setPerforated} checked={false === this.state.perforated} onClick={this.modal.showTrayChangeWarning} custom label="Неперфорированные" type="radio" id="tray_filter_unperforated" name="tray_filter" value="unperforated" />
                        <Form.Check onChange={this.setPerforated} checked={true === this.state.perforated} onClick={this.modal.showTrayChangeWarning} custom label="Перфорированые" type="radio" id="tray_filter_perforated" name="tray_filter" value="perforated" />
                    </div>
                </Form.Group>
            </Form.Row>            
            <AlertModal on_close={() => this.setState({alert_message: ''})} message={this.state.alert_message} /></>);
    }
}